<template lang="pug">
.draw-tools
  icon-dialog
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import iconDialog from "./iconDialog.vue";

export default {
  components: {
    "icon-dialog": iconDialog,
  },
  computed: {
    ...mapGetters("map", [
      "map",
      "markerMode",
      "markerList",
      "drawControl",
      "drawLayer",
      "drawOptions",
      "colorCanvas",
      "colorsLayer",
      "editMode",
    ]),
  },
  methods: {
    ...mapActions("map", [
      "setDrawControl",
      "setDrawLayer",
      "refreshDrawLayer",
      "setEditMode",
      "setMarkerMode",
      "addBlackShirube",
      "removeBlackShirube",
      "addSafeShirube",
      "addExRoute",
      "selectMarker",
    ]),
    initDrawControl() {
      // const _this = this;
      const { map } = this;
      // Leaflet.Drawの設定
      const controlOptions = this.drawOptions.default;
      // const iconOptions = this.drawOptions.icon;
      // 編集可レイアウト
      this.setDrawLayer(new L.FeatureGroup().addTo(map));
      controlOptions.edit.featureGroup = this.drawLayer;
      this.drawLayer
        .on("layeradd layerremove", (e) => {
          this.refreshDrawLayer();
        })
        .on("layeradd", (e) => {
          // console.log('add', e);
        })
        .on("layerremove", (e) => {
          // console.log('remove', e.layer, _this.drawLayer);
        });
      map.on('zoomend', ev => {
        const hasLayer = map.hasLayer(this.drawLayer);
        const z = ev.target.getZoom();
        if (15 <= z) {
          if (!hasLayer) {
            map.addLayer(this.drawLayer);
          }
        } else if (hasLayer) {
          map.removeLayer(this.drawLayer);
        }
      });
      // アイコン
      // const defaultMarker = new L.ExtraMarkers.Icon(iconOptions);
      // controlOptions.draw.marker.icon = defaultMarker;
      const _drawControl = new L.Control.Draw(controlOptions);
      map.addControl(_drawControl);
      this.setDrawControl(_drawControl);

      map
        // 描画開始時の処理
        .on(L.Draw.Event.DRAWSTART, (e) => {
          const { layer, layerType } = e;
          if (layerType === "marker") {
            // マーカの変更
            const iconOptions = this.markerList[this.markerMode].marker;
            iconOptions.markerId = this.markerMode;
            const drawOption = {
              marker: { icon: new L.icon(iconOptions) },
            };
            this.drawControl.setDrawingOptions(drawOption);
          } else if (layerType === "polyline") {
            if (this.map.getZoom() < 17) this.map.setZoom(17);
          }
        })
        // 描画キャンセル時の処理
        .on(L.Draw.Event.DRAWSTOP, (e) => {
          const { layerType } = e;
          if (layerType === "marker") {
            // マーカキャンセル
            this.setMarkerMode(-1);
          } else if (layerType === "polyline") {
            this.setEditMode(0);
          }
        })
        // 描画保存時の処理
        .on(L.Draw.Event.CREATED, (e) => {
          const { layer, layerType } = e;
          if (layerType === "marker") {
            this.initMarker(layer);
          } else if (layerType === "polyline") {
            layer.options.sid = 13;
            this.setExRoute(layer);
          }
        })
        // 編集保存時の処理
        .on(L.Draw.Event.EDITED, (e) => {
          const { layers } = e;
          const _this = this;
          layers.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              // キャンバスクリアしてからマーカの置き直し
              _this.clearCanvas(layer);
              // _this.removeClose(layer);
              _this.initMarker(layer);
            } else if (layer instanceof L.Polyline) {
              if (_this.drawLayer.hasLayer(layer))
                _this.drawLayer.removeLayer(layer);
              _this.setExRoute(layer);
            }
          });
        })
        // 削除保存時の処理
        .on(L.Draw.Event.DELETED, (e) => {
          const { layers } = e;
          const _this = this;
          layers.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              _this.clearCanvas(layer);
              // _this.removeClose(layer);
            } else if (layer instanceof L.Polyline) {
              if (_this.drawLayer.hasLayer(layer))
                _this.drawLayer.removeLayer(layer);
              // console.log(layer);
            }
          });
        });
    },
    initMarker(layer) {
      // マーカを設置する
      this.drawLayer.addLayer(layer);
      const { markerId } = layer.options.icon.options;
      layer.options.markerId = markerId;
      layer.on("click", (e) => {
        if (this.editMode) return false;
        e.originalEvent.preventDefault();
        this.selectMarker({ icon: layer, type: markerId });
        e.originalEvent.stopPropagation();
        return false;
      });
      if (markerId === 0) {
        // 避難所
        layer.options.colorCanvas = this.colorCanvas;
      } else if (markerId === 1) {
        layer.options.colorCanvas = this.colorCanvas;
        // 安全エリアはマルとバツを付加する
        // layer.options.pointCanvas = L.canvas({ pane: "pointMarker" });
        // this.addBlackRoute(layer, this.createCircle, {
        //   color: "#DD3E27",
        //   weight: 6,
        //   interactive: false,
        //   renderer: layer.options.pointCanvas,
        // }).then((closePoint) => {
        //   layer.options.closePoint = closePoint;
        //   this.addSafeRoute(layer, closePoint, this.createCloseGeojson, {
        //     style: {
        //       color: "#DD3E27",
        //       weight: 6,
        //       interactive: false,
        //     },
        //     renderer: layer.options.pointCanvas,
        //   });
        // });
      } else if (markerId === 2) {
        // 通行禁止にバツ
        layer.options.pointCanvas = L.canvas({ pane: "pointMarker" });
        this.addBlackRoute(layer, this.createCloseGeojson, {
          style: {
            color: "#211612",
            weight: 4,
            interactive: false,
          },
          renderer: layer.options.pointCanvas,
        }).then((closePoint) => {
          layer.options.closePoint = closePoint;
        });
      } else if (markerId === 3) {
        // 通行禁止にマル
        layer.options.pointCanvas = L.canvas({ pane: "pointMarker" });
        this.addBlackRoute(layer, this.createCircle, {
          color: "#DD3E27",
          weight: 3,
          interactive: false,
          renderer: layer.options.pointCanvas,
        }).then((closePoint) => {
          layer.options.closePoint = closePoint;
        });
      }
    },
    setExRoute(exLine) {
      const coords = L.GeoJSON.latLngsToCoords(exLine.getLatLngs());
      // 拡張ルートを設置する
      if (1 < coords.length) {
        // let exRouteInfo = {add: coords};
        // if (isEdited) exRouteInfo.remove = exLine.feature.geometry.coordinates;
        this.addExRoute(coords).then((newLine) => {
          if (newLine) {
            const exLatlngs = L.GeoJSON.coordsToLatLngs(newLine);
            const exLayer = L.geoJson(L.polyline(exLatlngs).toGeoJSON(), {
              // pane: 'exRoute',
              className: "ex_shirube",
              opacity: 0.6,
              weight: 10,
              renderer: L.svg({ pane: "exRoute" }),
            }).getLayers()[0];
            this.drawLayer.addLayer(exLayer);
          }
        });
      }
      this.setEditMode(0);
    },
    addBlackRoute(icon, createGeoJsonMethod, options) {
      // ブラックリストのルート追加
      const latlng = icon.getLatLng();
      return new Promise((resolve) => {
        return this.addBlackShirube(L.GeoJSON.latLngToCoords(latlng)).then(
          (coord) => {
            if (coord) {
              const closeLine = createGeoJsonMethod(coord, options).addTo(this.map);
              return resolve(coord);
            }
          }
        );
      });
    },
    addSafeRoute(icon, closePoint, createGeoJsonMethod, options) {
      // 安全ルートの追加
      return this.addSafeShirube({ icon: icon, close: closePoint }).then(
        (pos) => {
          if (pos) {
            const closeLine = createGeoJsonMethod(pos, options).addTo(this.map);
          }
        }
      );
    },
    createCloseGeojson(coord, options) {
      // ばつマークをつける
      const geojson = { type: "FeatureCollection", features: [] };
      geojson.features.push(
        L.polyline([
          [coord[1] - 0.00005, coord[0] - 0.00005],
          [coord[1] + 0.00005, coord[0] + 0.00005],
        ]).toGeoJSON()
      );
      geojson.features.push(
        L.polyline([
          [coord[1] - 0.00005, coord[0] + 0.00005],
          [coord[1] + 0.00005, coord[0] - 0.00005],
        ]).toGeoJSON()
      );
      return L.geoJson(geojson, options);
    },
    createCircle(coord, options, size = 6) {
      return L.circle([coord[1], coord[0]], size, options);
    },
    clearCanvas(layer) {
      // マーカ印と通行止めデータを削除
      const { pointCanvas } = layer.options;
      if (pointCanvas) {
        pointCanvas.remove();
        layer.options.pointCanvas = null;
      }
      const { closePoint } = layer.options;
      if (closePoint) {
        this.removeBlackShirube(closePoint);
        layer.options.closePoint = null;
      }
      // 色道を削除
      const { colorCanvas } = layer.options;
      if (colorCanvas) {
        colorCanvas.map((canvas) => canvas.remove());
        this.colorsLayer.eachLayer((_layer) => {
          if (_layer.options.iconIndex === layer._leaflet_id) {
            this.colorsLayer.removeLayer(layer);
            layer.options.colorCanvas = null;
          }
        });
      }
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (this.map) {
      this.initDrawControl();
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// public/pages/index/components/draw/index.vue